import API_CONFIG from '../../config/api';

async function fetchJson(url, { method = 'GET', token, body } = {}) {
  if (!token) {
    throw new Error('Authentication required.');
  }
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }
  const response = await fetch(url, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.detail || payload.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
  return payload;
}

export async function projectAutomationKnowledgeJobToPkb(projectId, jobId, body, token) {
  return fetchJson(
    `${API_CONFIG.BASE_URL}/automation/v1/knowledge/generation-jobs/${encodeURIComponent(jobId)}/project-to-pkb?project_id=${encodeURIComponent(projectId)}`,
    { method: 'POST', token, body },
  );
}

export async function retractAutomationKnowledgeJobProjections(projectId, jobId, body, token) {
  return fetchJson(
    `${API_CONFIG.BASE_URL}/automation/v1/knowledge/generation-jobs/${encodeURIComponent(jobId)}/projections/retract?project_id=${encodeURIComponent(projectId)}`,
    { method: 'POST', token, body },
  );
}

export async function listAutomationKnowledgeProjections(projectId, { generationJobId } = {}, token) {
  const params = new URLSearchParams({ project_id: String(projectId) });
  if (generationJobId) {
    params.set('generation_job_id', generationJobId);
  }
  return fetchJson(
    `${API_CONFIG.BASE_URL}/automation/v1/knowledge/projections?${params.toString()}`,
    { token },
  );
}
